import { call, put, takeEvery } from "redux-saga/effects";
import { toast } from "react-toastify";
import {
  FETCH_JOB_APPLICATION_LIST,
  CREATE_JOB_APP_CUSTOM_VIEW,
  FETCH_JOB_APP_CUSTOM_VIEW,
  FETCH_JOB_APP_CUSTOM_VIEW_BY_ID,
  DELETE_JOB_APP_CUSTOM_VIEW_BY_ID,
  SELECT_JOB_APP_CUSTOM_VIEW_BY_ID,
  UNSELECT_JOB_APP_CUSTOM_VIEW,
  EDIT_JOB_APP_CUSTOM_VIEW_BY_ID,
  UPDATE_JOB_APPLICATION_STATUS_BY_ID,
  REJECT_JOB_APPLICATION_BY_ID,
  FETCH_CANDIDATE_ID_BY_EMAIL,
} from "./actionTypes";
import {
  fetchJobApplicationListSuccess,
  fetchJobApplicationListFailure,
  createJobAppCustomViewSuccess,
  createJobAppCustomViewFailure,
  fetchJobAppCustomView,
  fetchJobAppCustomViewSuccess,
  fetchJobAppCustomViewFailure,
  fetchJobAppCustomViewByIdSuccess,
  fetchJobAppCustomViewByIdFailure,
  deleteJobAppCustomViewByIdSuccess,
  deleteJobAppCustomViewByIdFailure,
  selectJobAppCustomViewByIdSuccess,
  selectJobAppCustomViewByIdFailure,
  unselectJobAppCustomViewSuccess,
  unselectJobAppCustomViewFailure,
  editJobAppCustomViewByIdSuccess,
  editJobAppCustomViewByIdFailure,
  updateJobApplicationStatusByIdSuccess,
  updateJobApplicationStatusByIdFailure,
  rejectJobApplicationByIdSuccess,
  rejectJobApplicationByIdFailure,
  fetchCandidateIdByEmailSuccess,
  fetchCandidateIdByEmailFailure,
} from "./action";
import {
  getJobApplicationList,
  createJobAppCustomView,
  getJobAppCustomView,
  getJobAppCustomViewById,
  selectJobAppCustomViewById,
  unselectJobAppCustomView,
  deleteJobAppCustomView,
  editJobAppCustomViewById,
  updateJobApplicationStatusById,
  rejectJobApplicationById,
  getCandidateIdByEmail,
} from "../../helpers/backend_helper";

// Get job application list
function* workFetchJobApplicationList(action) {
  try {
    const response = yield call(getJobApplicationList, action.payload);
    yield put(fetchJobApplicationListSuccess(response));
  } catch (error) {
    yield put(fetchJobApplicationListFailure(error));
  }
}

// CUSTOMVIEW - create custom view
function* workCreateJobAppCustomView(action) {
  const { payload, navigate, closeFilter } = action.payload;
  try {
    const jobCustomViewResponse = yield call(createJobAppCustomView, payload);
    yield put(createJobAppCustomViewSuccess(jobCustomViewResponse));
    if (closeFilter) {
      yield put(fetchJobAppCustomView());
      toast.success("Job Application custom view created successfully!");
      closeFilter();
    } else {
      navigate("/jobs");
    }
  } catch (error) {
    yield put(createJobAppCustomViewFailure(error));
    if (error?.code === 409) {
      toast.error("Job Application custom view name already exists.");
    } else {
      toast.error("Error updating job application custom view!");
    }
  }
}

// CUSTOMVIEW - get all custom view
function* workFetchJobAppCustomView(action) {
  try {
    const response = yield call(getJobAppCustomView);
    yield put(fetchJobAppCustomViewSuccess(response));
  } catch (error) {
    yield put(fetchJobAppCustomViewFailure(error));
  }
}

// CUSTOMVIEW - get custom view by id
function* workFetchJobAppCustomViewById(action) {
  try {
    const response = yield call(getJobAppCustomViewById, action.payload);
    yield put(fetchJobAppCustomViewByIdSuccess(response));
  } catch (error) {
    yield put(fetchJobAppCustomViewByIdFailure(error));
  }
}

// CUSTOMVIEW - delete custom view by id
function* workDeleteJobAppCustomViewById(action) {
  const { id } = action.payload;
  try {
    const response = yield call(deleteJobAppCustomView, id);
    yield put(deleteJobAppCustomViewByIdSuccess(response));
    yield put(fetchJobAppCustomView());
    toast.success("Job Application default custom view selected");
  } catch (error) {
    yield put(deleteJobAppCustomViewByIdFailure(error));
    toast.error("Error deleting job application custom view!");
  }
}

// CUSTOMVIEW - select custom view by id
function* workSelectJobAppCustomViewById(action) {
  const { id } = action.payload;
  try {
    const response = yield call(selectJobAppCustomViewById, id);
    yield put(selectJobAppCustomViewByIdSuccess(response));
    yield put(fetchJobAppCustomView());
    toast.success("Job application custom view selected successfully!");
  } catch (error) {
    yield put(selectJobAppCustomViewByIdFailure(error));
    if (error.response && error.response.status === 409) {
      toast.error("Job application custom view name already exists.");
    } else {
      toast.error("Error creating job application custom view!");
    }
  }
}

// CUSTOMVIEW - unselect custom view
function* workUnselectJobAppCustomView(action) {
  try {
    yield call(unselectJobAppCustomView());
    yield put(unselectJobAppCustomViewSuccess());
    toast.success("Job application custom view unselected successfully!");
  } catch (error) {
    yield put(unselectJobAppCustomViewFailure(error));
    toast.error("Error unselecting job application custom view!");
  }
}

// CUSTOMVIEW - edit custom view by id
function* workEditJobAppCustomViewById(action) {
  const { editId, payload, navigate, closeFilter } = action.payload;
  try {
    const response = yield call(editJobAppCustomViewById, editId, payload);
    yield put(editJobAppCustomViewByIdSuccess(response));
    if (closeFilter) {
      yield put(fetchJobAppCustomView());
      toast.success("Job application custom view updated successfully!");
      closeFilter();
    } else {
      navigate("/jobs");
    }
  } catch (error) {
    yield put(editJobAppCustomViewByIdFailure(error));
    if (error?.code === 409) {
      toast.error("Job application custom view name already exists.");
    } else {
      toast.error("Error updating job application custom view!");
    }
  }
}

// Update job application status
function* workUpdateJobApplicationStatusById(action) {
  const { id, status } = action.payload;
  try {
    const response = yield call(updateJobApplicationStatusById, id, status);
    yield put(updateJobApplicationStatusByIdSuccess(response));
    toast.success("Job application status updated successfully!");
  } catch (error) {
    yield put(updateJobApplicationStatusByIdFailure(error));
    toast.error("Error updating job application status!");
  }
}

// Reject job application candidate by id
function* workRejectJobApplicationById(action) {
  const { id, rejectionReason } = action.payload;
  try {
    const response = yield call(rejectJobApplicationById, id, rejectionReason);
    yield put(rejectJobApplicationByIdSuccess(response));
  } catch (error) {
    yield put(rejectJobApplicationByIdFailure(error));
  }
}

// Fetch candidate id by email
function* workFetchCandidateIdByEmail(action) {
  try {
    const response = yield call(getCandidateIdByEmail, action.payload);
    yield put(fetchCandidateIdByEmailSuccess(response.data));
  } catch (error) {
    yield put(fetchCandidateIdByEmailFailure(error));
  }
}

export default function* watchFetchJobApplicationSaga() {
  yield takeEvery(FETCH_JOB_APPLICATION_LIST, workFetchJobApplicationList);
  yield takeEvery(CREATE_JOB_APP_CUSTOM_VIEW, workCreateJobAppCustomView);
  yield takeEvery(FETCH_JOB_APP_CUSTOM_VIEW, workFetchJobAppCustomView);
  yield takeEvery(FETCH_JOB_APP_CUSTOM_VIEW_BY_ID, workFetchJobAppCustomViewById);
  yield takeEvery(DELETE_JOB_APP_CUSTOM_VIEW_BY_ID, workDeleteJobAppCustomViewById);
  yield takeEvery(SELECT_JOB_APP_CUSTOM_VIEW_BY_ID, workSelectJobAppCustomViewById);
  yield takeEvery(UNSELECT_JOB_APP_CUSTOM_VIEW, workUnselectJobAppCustomView);
  yield takeEvery(EDIT_JOB_APP_CUSTOM_VIEW_BY_ID, workEditJobAppCustomViewById);
  yield takeEvery(UPDATE_JOB_APPLICATION_STATUS_BY_ID, workUpdateJobApplicationStatusById);
  yield takeEvery(REJECT_JOB_APPLICATION_BY_ID, workRejectJobApplicationById);
  yield takeEvery(FETCH_CANDIDATE_ID_BY_EMAIL, workFetchCandidateIdByEmail);
}